import React, { Component } from "react"
import PropTypes from "prop-types"
import Ambassador from "../ambassador"
import fetch from "cross-fetch"
import { flatMap } from "lodash"
import SbEditable from "storyblok-react"

import Select from "../input/Select"

class AmbassadorSearch extends Component {
  state = {
    loading: true,
    ambassador: [],
    offset: 0,
    total: 0,
    programs: [],
    campusFilter: [],
    programFilter: [],
  }

  componentDidMount() {
    this.search()

    fetch(
      `https://api.storyblok.com/v1/cdn/datasource_entries?datasource=ambassador-progams&token=${
        process.env.GATSBY_PUBLIC_SB_TOKEN
      }&ts=${Date.now ? Date.now() : new Date().getTime()}`
    )
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then((programs) => {
        this.setState({
          programs: programs.datasource_entries,
        })
      })
      .catch((err) => console.error(err))
  }

  search = (filtersObj) => {
    this.page += 1

    const filtersArr = this.filterHandler(filtersObj)
    const filters = filtersArr.flat()

    const { offset } = this.state

    fetch(`${process.env.GATSBY_HULTEDUDATA_API}/ambassador/search`, {
      method: "POST",
      body: JSON.stringify({
        from: offset,
        size: 100,
        filters,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then((result) => {
        this.setState({
          ambassador: flatMap(result.hits.hits, (f) => f._source),
          loading: false,
          total: result.hits.total,
          offset: this.page * this.size,
          campusFilter: filtersArr[0] || [],
          programFilter: filtersArr[1] || [],
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }

  campusOnChangeHandler = (event) => {
    const { value } = event.target

    const filterObj = {
      style: "tags",
      field: "Campus",
      options: [value],
    }

    this.search(filterObj)
  }

  programOnChangeHandler = (event) => {
    const { value } = event.target
    const filterObj = {
      style: "tags",
      field: "Program",
      options: [value],
    }

    this.search(filterObj)
  }

  filterHandler = (filterObj) => {
    const { campusFilter, programFilter } = this.state

    switch (filterObj && filterObj.field) {
      case "Campus":
        if (filterObj.options[0]) {
          return [filterObj, programFilter]
        } else {
          return [[], programFilter]
        }
      case "Program":
        if (filterObj.options[0]) {
          return [campusFilter, filterObj]
        } else {
          return [campusFilter, []]
        }
      default:
        return []
    }
  }

  render() {
    const { ambassador, programs } = this.state
    const { blok } = this.props

    return (
      <SbEditable content={blok}>
        <div className="ambassador-search">
          <div className="ambassador-search__toolbar card card--pd-md">
            <div className="grid grid--gutters-sm">
              <div className="grid__col grid__col--1-2">
                <Select
                  className="selector__campus"
                  label={blok.campus_filter_label}
                  text={"Filter by Campus"}
                  onChange={this.campusOnChangeHandler}
                >
                  <option selected="selected" key="AllCampus" value="">
                    All
                  </option>
                  {blok.campuses &&
                    blok.campuses.map((campus) => (
                      <option key={campus} value={campus}>
                        {campus}
                      </option>
                    ))}
                </Select>
              </div>
              <div className="grid__col grid__col--1-2">
                <Select
                  className="selector__program"
                  label={blok.program_filter_label}
                  text={"Filter by Program"}
                  onChange={this.programOnChangeHandler}
                >
                  <option selected="selected" key="AllPrograms" value="">
                    All
                  </option>
                  {programs &&
                    programs.map((program, index) => (
                      <option key={index} value={program.value}>
                        {program.name}
                      </option>
                    ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="search-results masonary masonary--4 masonary--sm-2">
            {ambassador.map((amb) => (
              <div key={`gridkey` + amb.Id} className="">
                <Ambassador
                  key={amb.Id}
                  url={`${blok.profile_path}?cid=${amb.Id}`}
                  img={amb.image}
                  firstName={amb.FirstName}
                  lastName={amb.LastName}
                  program={amb.ProgramTitle}
                  campus={amb.Campus}
                  interests={amb.Interests}
                />
              </div>
            ))}
          </div>
        </div>
      </SbEditable>
    )
  }
}

AmbassadorSearch.propTypes = {
  blok: PropTypes.shape({
    campuses: PropTypes.arrayOf(PropTypes.string),
    profile_path: PropTypes.string.isRequired,
    program_filter_label: PropTypes.string.isRequired,
    campus_filter_label: PropTypes.string.isRequired,
  }),
}

export default AmbassadorSearch
